import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type Currency = 'NGN' | 'USD'

interface CurrencyState {
  baseCurrency: Currency
  preferredCurrency: Currency
  exchangeRate: number // 1 NGN = X USD
  lastFetched: number | null

  // Actions
  setPreferredCurrency: (currency: Currency) => void
  fetchExchangeRate: () => Promise<void>
  togglePreferredCurrency: () => void
}

export const useCurrencyStore = create<CurrencyState>()(
  persist(
    (set, get) => ({
      baseCurrency: 'NGN',
      preferredCurrency: 'NGN',
      exchangeRate: 0.00065, // Default fallback (approx 1500 NGN = 1 USD)
      lastFetched: null,

      setPreferredCurrency: (currency) => set({ preferredCurrency: currency }),

      togglePreferredCurrency: () => {
        const current = get().preferredCurrency
        set({ preferredCurrency: current === 'NGN' ? 'USD' : 'NGN' })
      },

      fetchExchangeRate: async () => {
        const now = Date.now()
        const oneHour = 3600000
        const { lastFetched } = get()

        // Cache rate for 1 hour to avoid excessive API calls
        if (lastFetched && now - lastFetched < oneHour) return

        try {
          const res = await fetch('https://open.er-api.com/v6/latest/NGN')
          const data = await res.json()

          if (data && data.rates && data.rates.USD) {
            set({
              exchangeRate: data.rates.USD,
              lastFetched: now,
            })
          }
        } catch (error) {
          console.error('Failed to fetch exchange rate:', error)
          // Fallback is already set in initial state
        }
      },
    }),
    {
      name: 'kaat-currency',
      // Only persist preferredCurrency to avoid stale rates across long breaks
      partialize: (state) => ({ preferredCurrency: state.preferredCurrency }),
    }
  )
)
